export const selectErrors = ({ errors }) => errors?.lookup ?? {};
export const selectErrorsShown = ({ errors }) => errors?.shown ?? false;
export const selectErrorsToShow = ({ errors }) => errors?.errorsToShow ?? [];
